export default __webpack_public_path__ + "static/media/logo-thank-you.5d6795e2.svg";